import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './modal.css';
Modal.setAppElement('#root'); // Accessibility

function CustomModal(props) {
    const { primaryColor, border = 5, borderRadius = 40, backgroundColor = "white", modalIsOpen, setModalIsOpen } = props;

    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                className="custom-modal"
                overlayClassName="custom-modal-overlay"
                style={{
                    content: {
                        border: border + 'px solid ' + primaryColor,
                        borderRadius: borderRadius,
                        backgroundColor,
                    },
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#121212e9',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000,
                    }
                }}
            >
                {/* Close Button */}
                <button
                    onClick={() => setModalIsOpen(false)}
                    style={{
                        position: 'absolute',
                        top: '5px',
                        right: '15px',
                        // padding: '5px 10px',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '30px',
                    }}
                >
                    &times; {/* Close icon (X) */}
                </button>
                {
                    props.children
                }
            </Modal>
        </div>
    );
}

export default CustomModal;
